/**
 * Cloud access for `saved_buy_plans` <- localStorage `savedBuyPlans`
 * (unprefixed key). Frozen Split Buy plan snapshots; `tiers` (SavedPlanTier[])
 * goes into the JSONB column as-is. No CHECK constraints on this table.
 */
import type { SavedBuyPlan, SavedPlanTier } from '../../types/savedPlans';
import type { SavedBuyPlanRow } from './rows';
import { makeAppendTable } from './client';

function toRow(p: SavedBuyPlan, userId: string): SavedBuyPlanRow {
  return {
    id: p.id,
    user_id: userId,
    coin_id: p.coinId,
    coin_name: p.coinName,
    coin_ticker: p.coinTicker,
    coin_image: p.coinImage ?? null,
    total_budget: p.totalBudget,
    currency: p.currency,
    tiers: p.tiers,
    tier_count: p.tierCount,
    total_coins: p.totalCoins,
    avg_cost_basis: p.avgCostBasis,
    plan_name: p.planName,
    saved_at: p.savedAt,
  };
}

function fromRow(row: SavedBuyPlanRow): SavedBuyPlan {
  return {
    id: row.id,
    coinId: row.coin_id,
    coinName: row.coin_name,
    coinTicker: row.coin_ticker,
    ...(row.coin_image != null ? { coinImage: row.coin_image } : {}),
    totalBudget: Number(row.total_budget),
    currency: row.currency,
    tiers: (row.tiers ?? []) as SavedPlanTier[],
    tierCount: Number(row.tier_count),
    totalCoins: Number(row.total_coins),
    avgCostBasis: Number(row.avg_cost_basis),
    planName: row.plan_name,
    savedAt: row.saved_at,
  };
}

export const buyPlansTable = makeAppendTable<SavedBuyPlan, SavedBuyPlanRow>(
  'saved_buy_plans',
  toRow,
  fromRow
);
